import { ArticleService, type ArticlePremiumDO } from "./article.service"


export class ArticlePremiumContent extends HTMLElement {
    private language: 'french' | 'english' = "french"
    private slug: string = document.body.getAttribute("slug") ?? ""

    constructor(private articleService: ArticleService = window.tbwServices.articleService) {
        super()
    }

    async connectedCallback() {
        if (window.tbwServices.authService.isAuthenticated) {
            this.language = window.location.pathname.includes("article-en") ? "english" : "french"
            await this.render()
        }
    }

    async render() {
        const content = await this.getArticleContent()
        this.innerHTML = `
        <tbw-auth-state>
            <div slot="premium">
                <div class="text-rich-text w-richtext">
                    ${content.premiumContent}
                </div>
            </div>
        </tbw-auth-state>
        `

        // Dispatch event after content is actually in the DOM
        // Use setTimeout to ensure the browser has painted the content
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent("premiumContentLoaded", {
                bubbles: true,
                cancelable: true
            }))
        }, 0)
    }

    async getArticleContent(): Promise<ArticlePremiumDO> {
        const content = await this.articleService.get(this.slug, this.language)
        return content
    }
}